
import {
  defineComponent,
  ref,
  watch,
  onMounted,
} from '@vue/composition-api';
import {
  IconButton,
} from '@fc/angie-ui';
import FCSwiper from '~/components/FCSwiper.vue';
import FCImage from '~/components/FCImage.vue';
import { isMobileEffect } from '~/effects/matchMedia';

const coachesData = [
  {
    name: 'Aaron Swenson',
    igHandle: '@swensonboxing',
    imgUrl: 'https://a.storyblok.com/f/152150/1800x2400/5f0c23e263/aaron.jpg',
    bio: 'Aaron “Speedy” Swenson began training in his family’s Chicago dojo. By 2013, he earned two National Kickboxing titles and a USA Team spot. He’s a Founding FightCamp Coach and USA Boxing–certified.',
    accomplishments: [
      '2x National Kickboxing Champion',
      'USA National Kickboxing Team Member',
      'USA Boxing Coach Certified',
      'Founding FightCamp Coach',
      '20+ Years Martial Arts Experience',
    ],
  },
  {
    name: 'Selina Flores',
    igHandle: '@selinacflores',
    imgUrl: 'https://a.storyblok.com/f/152150/1800x2400/bf9bc3f456/selina.jpg',
    bio: 'Selina “The Teep Queen” Flores, a former gymnast from California, discovered Muay Thai as a teen, earning 11 National titles and the WBC World Championship. She recently won her ONE Championship debut and is rising fast.',
    accomplishments: [
      'Currently 1-0 in ONE Championship',
      '11x Amateur National Muay Thai Champion',
      'WBC Muay Thai World Champion',
      'Former North American Muay Thai Champion',
    ],
  },
  {
    name: 'Jerry "Flomaster" Randolph',
    igHandle: '@flomaster73',
    imgUrl: 'https://a.storyblok.com/f/152150/1800x2400/d81f05122b/flo.jpg',
    bio: 'A founding FightCamp coach, Jerry “Flo Master” Randolph channels decades of martial arts, dance, and performance into world-class conditioning — building precision, power, and control to help fighters perform under pressure and thrive beyond the ring. ',
    accomplishments: [
      'Founding FightCamp Coach',
      'Martial Artist & Movement Specialist',
      'Conditioning Coach for Anderson Silva, Usher & more',
      'World-Renowned Dancer for Usher, Chris Brown, Britney Spears & more',
      '20+ Years Experience in Functional Strength & Power Training',
    ],
  },
  {
    name: 'Jessica Evans',
    igHandle: '@jessevansfit',
    imgUrl: 'https://a.storyblok.com/f/152150/1800x2400/75a905b30c/jess.jpg',
    bio: 'Jess “Pocket Rocket” Evans began boxing in 2012, later training at Australia’s Bulldog Gym and earning three state titles in the 52 kg division. Now a full-time FightCamp Coach, she’s also a certified USA Boxing Coach.',
    accomplishments: [
      '3x State Titles (52kg division, Australia)',
      'Amateur Muay Thai record: 7-2',
      'Amateur Boxing record: 2-1',
      'USA Boxing Coach Certified',
    ],
  },
  {
    name: 'Charlotte Rose Craig',
    igHandle: '@charlotte_rose49',
    imgUrl: 'https://a.storyblok.com/f/152150/1800x2400/27bc801c30/charlotte.jpg',
    bio: 'Charlotte Rose Craig, a 13-time USA Taekwondo National Team member and 2008 Olympian, brings 20+ years of elite experience to FightCamp, blending Olympic discipline and MMA adaptability to teach precision, composure, and the fighter’s mindset.',
    accomplishments: [
      'U.S. Olympic Team, Beijing 2008 (Taekwondo, 49kg division)',
      '13x USA Taekwondo National Team Member',
      'Professional MMA Fighter (Strawweight)',
      'FightCamp Coach — Striking & Martial Arts',
    ],
  },
  {
    name: 'Tommy Duquette',
    igHandle: '@tommyduquette',
    imgUrl: 'https://a.storyblok.com/f/152150/1800x2400/5ed4aa96b4/tommy.jpg',
    bio: 'Tommy Duquette, former USA National Team boxer and Olympic Alternate ranked #2 at 132 lbs, fought in over 130 matches. He co-founded FightCamp to share real boxing—precision, speed, and discipline—with anyone willing to work.',
    accomplishments: [
      'Co-Founder of FightCamp',
      'Former USA National Boxing Team Member',
      'Olympic Team No 2 seed | Ranked #2 at 132 lbs',
      '100+ Amateur Fights',
      'USA Boxing Coach Certified',
    ],
  },
];

export default defineComponent({
  name: 'CoachesSection',
  components: {
    FCSwiper,
    IconButton,
    FCImage,
  },
  props: {},
  setup() {
    const swiperRef = ref<InstanceType<typeof FCSwiper> | null>(null);
    const isFirstSlide = ref(true);
    const isMobile = isMobileEffect();
    const showNavigation = ref(false);

    const handleSlideClick = (index: number) => {
      if (swiperRef.value) {
        swiperRef.value.goToSlide(index);
      }
    };

    const handleMeetCoaches = () => {
      if (swiperRef.value) {
        swiperRef.value.goToSlide(1);
      }
    };

    const handlePrevSlide = () => {
      if (swiperRef.value) {
        swiperRef.value.handlePrevSlide();
      }
    };

    const handleNextSlide = () => {
      if (swiperRef.value) {
        swiperRef.value.handleNextSlide();
      }
    };

    const handleSlideChange = (event: any) => {
      isFirstSlide.value = event.activeIndex === 0;
    };

    // Set showNavigation after mount to avoid hydration mismatch
    onMounted(() => {
      showNavigation.value = isMobile.value;
    });

    // Watch for changes in isMobile (e.g., window resize)
    watch(isMobile, (newValue) => {
      showNavigation.value = newValue;
    });

    return {
      swiperRef,
      handleSlideClick,
      coachesData,
      handleMeetCoaches,
      handlePrevSlide,
      handleNextSlide,
      isFirstSlide,
      handleSlideChange,
      isMobile,
      showNavigation,
    };
  },
});
